import React from 'react';
import { Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

//착수보고/분석설계/구축(이행)/완료(검수)
const RsltStatusChip = (params) => {
    let color = 'primary';
    let label = "";
    switch (params.row.rsltStatus) {
        case 'S':
            color = 'info';
            label = "결재중"
            break;
        case 'Y':
            color = 'success';
            label = "결재완료"
            break;
        case 'N':
            color = 'default';
            label = "거부"
            break;

        default:
            color = 'default';
            break;
    }

    return (
        <Chip
            icon={<CircleIcon />}
            label={label}
            variant="outlined"
            color={color}
        />
    );
};

export default RsltStatusChip;
